<template>
    <div class="container-fluid p-3">
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column">
                <div class="title d-flex align-items-center">
                    <inline-svg class="me-2" width="36" height="36" src="/assets/img/icons/file-heart-01.svg"></inline-svg>
                    My Card Decks
                </div>
                <div class="subtitle">24 Total Cards</div>
            </div>
            <div class="d-flex flex-column">
                <btn class="btn btn-primary" @click="addCardDeck">
                    <inline-svg class="me-1" src="/assets/img/icons/file-plus-01.svg"></inline-svg>
                    Create a New Card Deck
                </btn>
            </div>
        </div>
<!--        List of card decks-->
        <card-decks-list @onEditCardDeckItem="handleEditCardDeck" :categoryFilterOptions="categoryFilterOptions"></card-decks-list>
        <modal name="addCardModal"
               :adaptive="true"
               :width="1000" height="auto" :maxWidth="1000"
               :scrollable="true"
               class="pt-3 pb-3"
               :clickToClose="false"
               :keyboard="false"
        >
            <div :class="{loading: loading.closeAddCardModal}">
                <div class="modal-header">
                    <h4 class="modal-title">{{ cardDeck.id ? 'Update Card Deck' : 'Create Card Deck' }}</h4>
                    <button type="button"
                            class="btn-close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            @click="closeAddCardModal">
                    </button>
                </div>
                <div class="divider --top-20"></div>
                <div v-if="step === 1" class="card-modal__body pt-1" style="width: auto">
                    <inline-svg height="32" width="52" src="/assets/img/logo/logo_big_hand_wave_primary.svg"></inline-svg>
                    <div class="card-modal__title">Select a Card Deck Category</div>
                    <div class="card-modal__subtitle">
                        Select a Card Deck category. The category you select will be where the published Card Deck can be found in the Heroes MagnusCards app, and in MagnusTeams.
                    </div>
                    <div class="row mt-3">
                        <div class="col-6 scrollbar-visible">
                            <VuePerfectScrollbar style="height: 400px; padding-right: 10px">
                                <div class="card-modal__category-grid">
                                    <a href="#" class="link-black" @click.prevent="selectCategory(category)" v-for="category in categories">
                                        <category-card-small :class="{active: category.value === cardDeck.category.value}"
                                                             :category="category">
                                        </category-card-small>
                                    </a>
                                </div>
                            </VuePerfectScrollbar>
                        </div>
                        <div class="col-6 d-flex flex-column flex-1">
                            <form-input :v="$v.cardDeck.title"
                                        label="Card Deck Title*"
                                        placeholder="Insert the title of the activity this Card Deck will cover"
                                        v-model="cardDeck.title"/>
                            <label class="text-bold-600" style="margin-top: 24px">Card Deck Cover Image</label>
                            <image-uploader hint="If you don't attach an image here, we will use the image from the first card as your cover."
                                            :card_deck_id="cardDeck.id"
                                            image_type="deck"
                                            :editable="true"
                                            upload_link_message="Click to add the Card Deck cover image"
                                            v-model="cardDeck.central_image">
                            </image-uploader>
                        </div>
                    </div>
                </div>
                <div v-else-if="step === 2" class="card-modal__cards" style="width: auto">
                    <div class="card-modal__title">
                        <inline-svg height="48" src="/assets/img/logo/logo_big_hand_wave_primary.svg"></inline-svg>
                        Add Cards to Your Card Deck
                    </div>
                    <div class="card-modal__subtitle">
                        Each Card is a step in the process. Add a photo and/or description for each Card.
                    </div>
                    <div class="d-flex flex-row gap-3">
                        <div class="d-flex flex-column flex-1" style="min-width: 300px">
                            <image-uploader class="pb-2"
                                            hint="If you don’t have a photo, we will use a placeholder image"
                                            image_type="deck"
                                            :editable="true"
                                            style="min-height: 400px"
                                            :card_id="selectedCard.id"
                                            v-model="selectedCard.image">
                            </image-uploader>
                            <form-textarea rows="3" placeholder="Add a short and concise description for this step"  label="Description" v-model="selectedCard.description"/>
                        </div>
                        <div class="d-flex flex-column pt-1" style="max-height: 550px;">
                            <div class="d-flex flex-column flex-1 pt-1" style="max-height: 400px; width: 130px; overflow: hidden">
                                <VuePerfectScrollbar id="cardsScrollArea" class="custom-scrollbar">
                                    <draggable
                                        class="list-group p-0"
                                        tag="ul"
                                        v-model="cardDeck.cards"
                                        v-bind="dragOptions"
                                        @start="drag = true"
                                        @end="drag = false"
                                    >
                                        <div :ref="'card' + index" class="card-deck-card"
                                             :class="{'selected': card === selectedCard}"
                                             @click="selectCard(card)"
                                             v-for="(card, index) in cardDeck.cards">
                                            <img v-if="card.image" :src="card.image">
                                            <img v-else src="/assets/img/backgrounds/no-image-background.svg">
                                            <div class="card-deck-card__counter-label floating" :class="{'selected': card === selectedCard}">
                                                Card {{index + 1}}
                                            </div>
                                            <div v-if="index > 0"
                                                 class="card-deck-card__close-btn"
                                                 :class="{'selected': card === selectedCard}"
                                                 @click.prevent="deleteCard(index)">
                                                <inline-svg src="/assets/img/icons/x-circle.svg"></inline-svg>
                                            </div>
                                        </div>
                                    </draggable>

                                </VuePerfectScrollbar>
                            </div>
                            <div @click.prevent="addCard" class="card-deck-card-add">
                                <inline-svg class="mb-1" src="/assets/img/icons/plus-square.svg"></inline-svg>
                                Add Card
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="step === 3" class="modal-body" style="width: auto">
                    <card-deck-preview :cardDeck="cardDeck"></card-deck-preview>
                </div>
                <div class="card-modal__footer mt-3">
                    <div>
                        <span class="counter">Step {{step}} of 3
                        </span>
                    </div>
                    <div class="d-flex gap-2">
                        <btn v-if="step > 1" class="btn-outline-light btn-lg" @click="previousStep">
                            <inline-svg src="/assets/img/icons/back-icon-md.svg" class="me-1"></inline-svg>
                            Previous
                        </btn>
                        <btn v-if="step !== 3"
                             :loading="loading.save"
                             class="btn-primary btn-lg"
                             :class="{disabled: !(cardDeck.category.value && cardDeck.title)}"
                             @click="nextStep">
                            Next
                            <inline-svg src="/assets/img/icons/right-arrow.svg" class="ms-1"></inline-svg>
                        </btn>
                        <btn v-else class="btn-primary btn-lg" :loading="loading.save" @click="saveCardDeck">
                            {{ cardDeck.id ? 'Update Card Deck' : 'Create Card Deck' }}
                            <inline-svg src="/assets/img/icons/file-heart-01-white.svg" class="ms-1"></inline-svg>
                        </btn>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="sharingConfirmationModal" height="auto" width="400px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <inline-svg src="/assets/img/avatar-group.svg"></inline-svg>
                </div>
                <div class="modal-body">
                    <h4 class="modal-title text-center">Thanks for sharing!</h4>
                    <div class="modal-subtitle-gray text-center">In order to keep our community safe, we will review Card Decks that are shared.
                        <br><br>Don't worry, chances are your Card Deck will be shared within 24 hours.</div>
                </div>
                <div class="divider --top-12"></div>
                <div class="d-flex flex-row justify-content-between gap-2" style="padding: 24px">
                    <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('sharingConfirmationModal')">Understood</btn>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import {required} from "vuelidate/lib/validators";
import CardDeckPreview from "@/components/CardDeckPreview.vue";
import CardDecksList from "@/views/CardDecks/CardDecksList.vue";
import CategoryCardSmall from "@/components/CategoryCardSmall.vue";
import ImageUploader from "@/components/ImageUploader.vue";
import draggable from 'vuedraggable'
import {mapState} from 'vuex';
import {modelListMixin} from "/src/mixins/modelListMixin.js";
import card from "@/components/Card.vue";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    name: 'MyCardDecks',
    components: {ImageUploader, CategoryCardSmall, CardDecksList, CardDeckPreview, draggable, VuePerfectScrollbar },
    mixins: [modelListMixin],
    data() {
        return {
            loading: {
                save: false,
                closeAddCardModal: false,
            },
            cardDeck: {
                title: '',
                category: {},
                central_image: '',
                owner_id: null,
                cards: [
                    {
                        sort_by: 1,
                        description: '',
                        image: null,
                    }
                ]
            },
            selectedCard: {
                image: ''
            },
            step: 1,
            lastStep: 1,
            categories: [],
            filters: {
                status: '',
            },
            categoryFilterOptions: [],
        };
    },
    validations: {
        cardDeck: {
            title: {required: required},
        },
    },
    computed: {
        card() {
            return card
        },
        ...mapState({
            user: (state) => state.user,
        }),
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
                scrollSensitivity: 200,
                forceFallback: true
            };
        }
    },
    created() {
        this.selectedCard = this.cardDeck.cards[0];
    },
    mounted() {
        this.getCategories();
        this.cardDeck.owner_id = this.user.uuid;
        if (this.$route.params.openAddCardDeck) {
            this.$modal.show('addCardModal');
        }
    },
    methods: {
        getCategories() {
            this.$http.get("/category/all")
                .then((res) => {
                    this.categories = res.body.data.categories;
                    this.categoryFilterOptions = res.body.data.categories.slice();
                    this.categoryFilterOptions.unshift({label: 'All Card Decks', value: null});
                })
                .catch((error) => {
                    console.log(error)
                });

        },
        nextStep() {
            this.step++;
        },
        previousStep() {
            this.step--;
        },
        addCardDeck() {
            this.step = 1;
            this.cardDeck = {
                title: '',
                category: {},
                central_image: '',
                    owner_id: null,
                    cards: [
                    {
                        id: null,
                        sort_by: 1,
                        description: '',
                        image: null,
                    }
                ]
            };
            this.selectedCard = this.cardDeck.cards[0];
            this.$modal.show('addCardModal');
        },
        saveCardDeck() {
            this.$v.cardDeck.$touch();
            if (this.$v.cardDeck.$invalid == true) {
                return false;
            }
            this.loading.save = true;
            let url = this.cardDeck.id ? this.cardDeck.deck_copied ? "/deck/clone-deck" : "/deck/update" : "/deck/create";
            this.$http.post(url, this.cardDeck)
                .then((res) => {
                    this.loading.save = false;
                    this.$events.emit('loadMyCardDecks');
                    this.$modal.hide('addCardModal');
                })
                .catch((error) => {
                    this.loading.save = false;
                });
        },
        addCard() {
            const newCard = {
                id: null,
                sort_by: this.cardDeck.cards.length + 1,
                description: '',
                image: '',
            }
            this.cardDeck.cards.push(newCard);
            this.selectedCard = newCard;

            setTimeout(() => {
                var cardsScrollArea = this.$el.querySelector("#cardsScrollArea");
                cardsScrollArea.scrollTop = cardsScrollArea.scrollHeight;
            })
        },
        deleteCard(index) {
            this.cardDeck.cards.splice(index, 1);
        },
        selectCategory(category) {
            this.cardDeck.category = category;
        },
        selectCard(card) {
            this.selectedCard = card;
        },
        handleEditCardDeck(cardDeck) {
            this.step = 1;
            this.cardDeck = JSON.parse(JSON.stringify(cardDeck));
            this.selectedCard = this.cardDeck.cards[0];
            this.$modal.show('addCardModal')
        },
        closeAddCardModal() {
            if (this.cardDeck.id === undefined) {
                let filePaths = [];
                if (this.cardDeck.central_image) {
                    filePaths.push(this.cardDeck.central_image);
                }
                for (const card of this.cardDeck.cards)
                {
                    if (card.image) {
                        filePaths.push(card.image);
                    }
                }
                if (!filePaths.length) {
                    this.$modal.hide('addCardModal')
                    return;
                }
                this.loading.closeAddCardModal = true;
                this.$http.post('/delete-files', {filePaths: filePaths})
                    .then((res) => {
                        this.loading.closeAddCardModal = false;
                        this.$modal.hide('addCardModal')
                    })
                    .catch((error) => {
                        this.loading.closeAddCardModal = false;
                        console.log(error)
                    });
            } else {
                this.$modal.hide('addCardModal')
            }
        }
    }
};
</script>





